import {
  LayerSchemaConfig,
  LayerSchemaConfigProperty,
  LayerStyles,
} from '@packages/database/types';

export const getPrimaryLabelField = (
  schema?: LayerSchemaConfig,
): LayerSchemaConfigProperty | null => {
  return (
    schema?.properties.find((p) => p.isLabel) ?? schema?.properties[0] ?? null
  );
};

// export const getMapLabelField = (
//   styles: LayerStyles,
// ): LayerSchemaConfig | null => {
//   return (
//     styles.label?.field
//   );
// };

export const getCardFields = (
  schema: LayerSchemaConfig,
): LayerSchemaConfigProperty[] => {
  return schema.properties.filter((p) => p.showInCard);
};

export const getPopupFields = (
  schema: LayerSchemaConfig,
): LayerSchemaConfigProperty[] => {
  return schema.properties.filter((p) => p.showInPopup);
};

export const getDetailFields = (
  schema: LayerSchemaConfig,
): LayerSchemaConfigProperty[] => {
  return schema.properties.filter((p) => p.showInDetail);
};

export const getFormFields = (
  schema: LayerSchemaConfig,
): LayerSchemaConfigProperty[] => {
  return schema.properties.filter((p) => p.showInForm);
};
